import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IconButton, Menu } from '@mui/material'
import { Close, MoreVert } from '@mui/icons-material'
import _ from 'lodash'

import { selectHasExecutePermissions } from 'store/selectors/user'

const CardActions = ({ funder, opportunityId, actions = [], loadData }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState()
  const [Dialog, setDialog] = useState()

  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  const handleOpen = ({ currentTarget }) => {
    setIsOpen(true)
    setAnchorEl(currentTarget)
  }

  if (!actions.length) return null
  if (!hasExecutePermissions) return null

  return (
    <div className="Material-cards-actions-wrapper">
      <IconButton className="Material-cards__expanded-actions" onClick={handleOpen}>
        <MoreVert />
      </IconButton>
      <Menu
        className="Material-cards__expanded-actions-menu-wrapper"
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={() => setIsOpen(false)}
      >
        <IconButton onClick={() => setIsOpen(false)}>
          <Close />
        </IconButton>

        {actions
          .filter(item => item)
          .map((Action, index) => (
            <Action
              key={index}
              funder={funder}
              opportunityId={opportunityId}
              setShowDialog={dialog => {
                setIsOpen(false)
                setDialog(() => dialog)
              }}
              loadData={loadData}
              dispatch={dispatch}
            />
          ))}
      </Menu>
      {!!Dialog && Dialog}
    </div>
  )
}

export default CardActions
